import { get_session9cytjmfbg8nd as get_session } from '../../sdk/UserSession.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../components/nav/crowpay.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import {
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
  Companion_getInstance1350ksylxva5s as Companion_getInstance,
  Set2awzlbbrsme5i as Set,
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  Frame1e7t2kcdb3wu7 as Frame,
  RowOrCol3a33s3yce2tuv as RowOrCol,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import { get_appThemejy2o9bdilpry as get_appTheme } from '../theming/appTheme.mjs';
import {
  title1nssp3ryhwuqj as title,
  body3i5t0n7zprpqb as body,
} from '../theming/Titles.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { label287uhiq3m9m4z as label2 } from '../components/label2.mjs';
import {
  get_deleteButton1v46c8rhktdg5 as get_deleteButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_textButtonybbt8y3eu5hx as get_textButton,
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
} from '../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.vfw().dfh_1.ofs($this.bib_1.yia_1.h70_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  get_dialogStack().pgd();
  var tmp_1 = $this.bib_1.zia_1($this.cib_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.vfw().dfh_1.nfs($this.dib_1.yia_1.h70_1, $this.dib_1.aib_1.f2(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  get_dialogStack().pgd();
  var tmp_1 = $this.dib_1.zia_1($this.eib_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return Unit_instance;
}
var EditMethodDialog$render$slambdaClass;
function EditMethodDialog$render$slambda() {
  if (EditMethodDialog$render$slambdaClass === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditMethodDialog$render$slambdaClass = $;
  }
  return EditMethodDialog$render$slambdaClass;
}
function EditMethodDialog$render$slambda_0() {
  var i = new (EditMethodDialog$render$slambda())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var EditMethodDialog$render$slambdaClass_0;
function EditMethodDialog$render$slambda_1() {
  if (EditMethodDialog$render$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.bib_1 = this$0;
        this.cib_1 = $$this$button;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditMethodDialog$render$slambdaClass_0 = $;
  }
  return EditMethodDialog$render$slambdaClass_0;
}
function EditMethodDialog$render$slambda_2(this$0, $$this$button) {
  var i = new (EditMethodDialog$render$slambda_1())(this$0, $$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var EditMethodDialog$render$slambdaClass_1;
function EditMethodDialog$render$slambda_3() {
  if (EditMethodDialog$render$slambdaClass_1 === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditMethodDialog$render$slambdaClass_1 = $;
  }
  return EditMethodDialog$render$slambdaClass_1;
}
function EditMethodDialog$render$slambda_4() {
  var i = new (EditMethodDialog$render$slambda_3())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var EditMethodDialog$render$slambdaClass_2;
function EditMethodDialog$render$slambda_5() {
  if (EditMethodDialog$render$slambdaClass_2 === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.dib_1 = this$0;
        this.eib_1 = $$this$button;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditMethodDialog$render$slambdaClass_2 = $;
  }
  return EditMethodDialog$render$slambdaClass_2;
}
function EditMethodDialog$render$slambda_6(this$0, $$this$button) {
  var i = new (EditMethodDialog$render$slambda_5())(this$0, $$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var EditMethodDialog$render$slambdaClass_3;
function EditMethodDialog$render$slambda_7() {
  if (EditMethodDialog$render$slambdaClass_3 === VOID) {
    class $ {
      uao($completion) {
        return Unit_instance;
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditMethodDialog$render$slambdaClass_3 = $;
  }
  return EditMethodDialog$render$slambdaClass_3;
}
function EditMethodDialog$render$slambda_8() {
  var i = new (EditMethodDialog$render$slambda_7())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var EditMethodDialogClass;
function EditMethodDialog() {
  if (EditMethodDialogClass === VOID) {
    class $ {
      constructor(method, onUpdate) {
        this.yia_1 = method;
        this.zia_1 = onUpdate;
        var tmp = this;
        var tmp0_elvis_lhs = this.yia_1.i70_1;
        tmp.aib_1 = Signal().hak(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs);
      }
      wd6(_this__u8e3s4) {
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.vbo(EditMethodDialog$render$slambda_0());
        var tmp = view.kbb(view.jbb(DialogSemantic_getInstance()), get_centered(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.gba(get_AppDimensions().yg1_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_1.zbm(true);
        Companion_getInstance();
        // Inline function 'com.lightningkite.kiteui.models.Companion.invoke' call
        var theme = get_appTheme();
        var tmp$ret$0 = new (Set())(theme);
        view_1.lba(tmp$ret$0);
        title(view_1, 'Edit Method');
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (Space())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.gbb(p_2, view_2);
        view_1.hbb(p_2, view_2);
        label2(view_1, 'Name', VOID, ($this$label2) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp = $this$label2.jbb(FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.textField' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextInput())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.gbb(p, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
          var value = 'Method Name';
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          view.vb5_1.bb4_1.kb7_1.placeholder = value;
          view.zah(view.icn_1, this.aib_1);
          $this$label2.hbb(p, view);
          return $this$label2.lbb(tmp, view);
        });
        label2(view_1, 'Bank Name', VOID, ($this$label2) => {
          var tmp0_safe_receiver = this.yia_1.j70_1;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.o9l_1;
          return body($this$label2, tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
        });
        label2(view_1, 'Account Number', VOID, ($this$label2) => {
          var tmp0_safe_receiver = this.yia_1.j70_1;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m9l_1;
          return body($this$label2, '*** ***' + (tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs));
        });
        label2(view_1, 'Routing Number', VOID, ($this$label2) => {
          var tmp0_safe_receiver = this.yia_1.j70_1;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n9l_1;
          return body($this$label2, tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Space())(view_1.pc());
        var tmp0_elvis_lhs_3 = view_1.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
        view_1.gbb(p_3, view_3);
        view_1.hbb(p_3, view_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_4 = view_1.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_1 : tmp0_elvis_lhs_4;
        view_1.gbb(p_4, view_4);
        view_4.zbm(false);
        var tmp_0 = get_deleteButton(view_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (Button())(view_4.pc());
        var tmp0_elvis_lhs_5 = view_4.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
        view_4.gbb(p_5, view_5);
        specCenteredText(view_5, 'Delete');
        onClick(view_5, VOID, VOID, EditMethodDialog$render$slambda_2(this, view_5));
        view_4.hbb(p_5, view_5);
        view_4.lbb(tmp_0, view_5);
        var tmp_1 = get_expanding(view_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (Space())(view_4.pc());
        var tmp0_elvis_lhs_6 = view_4.ebb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
        view_4.gbb(p_6, view_6);
        view_4.hbb(p_6, view_6);
        view_4.lbb(tmp_1, view_6);
        var tmp_2 = get_textButton(view_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (Button())(view_4.pc());
        var tmp0_elvis_lhs_7 = view_4.ebb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_4 : tmp0_elvis_lhs_7;
        view_4.gbb(p_7, view_7);
        specCenteredText(view_7, 'Cancel');
        onClick(view_7, VOID, VOID, EditMethodDialog$render$slambda_4());
        view_4.hbb(p_7, view_7);
        view_4.lbb(tmp_2, view_7);
        var tmp_3 = get_tertiaryButton(view_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (Button())(view_4.pc());
        var tmp0_elvis_lhs_8 = view_4.ebb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_4 : tmp0_elvis_lhs_8;
        view_4.gbb(p_8, view_8);
        var tmp_4 = KMutableProperty0();
        var tmp_5 = Button$_get_enabled_$ref_61t7nx(view_8);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('enabled', 0, tmp_4, tmp_5, Button$_set_enabled_$ref_o8kynz(view_8));
        reactiveScope(view_8, ($this$reactiveScope) => {
          // Inline function 'kotlin.text.isNotBlank' call
          var this_1 = $this$reactiveScope.daj(this.aib_1);
          var tmp$ret$23 = !isBlank(this_1);
          this_0.set(tmp$ret$23);
          return Unit_instance;
        });
        specCenteredText(view_8, 'Save');
        onClick(view_8, VOID, VOID, EditMethodDialog$render$slambda_6(this, view_8));
        view_4.hbb(p_8, view_8);
        view_4.lbb(tmp_3, view_8);
        view_1.hbb(p_4, view_4);
        view_0.hbb(p_1, view_1);
        view.hbb(p_0, view_0);
        view.lbb(tmp, view_0);
        view.vbo(EditMethodDialog$render$slambda_8());
        _this__u8e3s4.hbb(p, view);
        return view;
      }
    }
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'EditMethodDialog', VOID, VOID, [Page()]);
    EditMethodDialogClass = $;
  }
  return EditMethodDialogClass;
}
//region block: exports
export {
  EditMethodDialog as EditMethodDialogf2d0knlmpnxu,
};
//endregion

//# sourceMappingURL=EditMethodDialog.mjs.map
